module.exports = __webpack_public_path__ + "img/shy.84fd7397.png";